<template>
    <div class="filter-wrap">
        <div class="filter-title" @click="executeAnimation()">
            <div>范围</div>
            <span>{{!isShow ? '展开':"隐藏"}}</span>
            <img id="img" class="animation-img" src="@/assets/images/result/send_down_icon.png" alt="">
        </div>
        <transition name="fade-transform" mode="out-in">
            <div id="content-box" v-show="isShow">
                <div class="select-wrap">
                    <div class="select-top-wrap select-left">
                        <div class="select-item" @click="openSelect(0)">
                            <div>{{ areaForm[0].title || '大区' }}</div>
                            <img src="@/assets/images/result/chevron-down.png" alt="">
                        </div>
                        <div class="select-item" @click="openSelect(1)">
                            <div>{{ areaForm[1].title || '城市' }}</div>
                            <img src="@/assets/images/result/chevron-down.png" alt="">
                        </div>
                    </div>
                    <div class="select-item select-right" @click="openSelect(2)">
                        <div>{{ areaForm[2].title || '渠道' }}</div>
                        <img src="@/assets/images/result/chevron-down.png" alt="">
                    </div>
                    <div class="select-item select-left" @click="openSelect(3)">
                        <div>{{ areaForm[3].title || '代理商' }}</div>
                        <img src="@/assets/images/result/chevron-down.png" alt="">
                    </div>
                    <div class="select-item select-right" @click="openSelect(4)">
                        <div>{{ areaForm[4].title || '签单手' }}</div>
                        <img src="@/assets/images/result/chevron-down.png" alt="">
                    </div>
                </div>
                <div class="filter-title">
                    <div>周期</div>
                </div>

                <div class="cycle-wrap">
                    <div v-for="(item, index) in dateList" :key="index" :class="['cycle-item', index === curDate && 'cycle-item-act']" @click="changeSelectDate(index)">{{ item.title }}</div>
                </div>
                <transition name="fade-transform" mode="out-in">
                    <div id="choose-time" class="cycle-wrap" >
                        <div class="date_time" @click="bDateTime = true,typeTime = 'startTime'">{{startTime?startTime:'自定义开始时间'}}</div>至<div class="date_time" @click="bDateTime = true,typeTime = 'endTime'">
                            {{endTime?endTime:'自定义结束时间'}}</div>
                    </div>
                </transition>
                <van-popup round position="bottom" v-model="popShow">
                    <van-search v-if="curSelect == 3 || curSelect == 4" v-model="scartext" @input='searchText' placeholder="请输入搜索关键词" />
                    <van-picker :title="selectTitle" value-key="title" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="popShow = false" />
                </van-popup>
                <!-- 时间选择器 -->
                <van-popup round position="bottom" v-model="bDateTime">
                    <van-datetime-picker v-model="currentDate" @cancel="getCancel" @confirm="getConfirm" type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate" />
                </van-popup>
            </div>
        </transition>
    </div>
</template>

<script>
import oAnalysisJs from "@/js/hvac/performance/result.js";
import { log } from "@antv/g2plot/lib/utils";
import {fetchVerifyAuthForB}  from "@/libsV2/havc.js";
import common from "@/common/common";
import { getsearch } from '@/js/house/index.js';

export default {
    // 业绩在线 筛选
    props: {
        newtime: {
            type: Boolean,
            default: () => false,
        }
    },
    created() {
        // $init(() => {
        //     this.sPhone = this.$route.query.phone;
        //     this.getPerformanceSearch();
        // });

    if(this.newtime) {
        this.dateList.forEach((item, index) => {
            if(index == 0) {
                item.start = '2021-01-01';
                item.end = common.getDate(); //当前时间
            } else if(index == 1) {
                item.start = (common.getDate().slice(0, 4) - 1) + '-01-01';
                item.end = common.getDate(); //当前时间
            } else if(index == 2) {
                item.start = common.getday(common.getDate(), -30);
                item.end = common.getDate(); //一个月
            } else if(index == 3) {
                item.start = common.getday(common.getDate(), -7);
                item.end = common.getDate(); // 一周
            } else if(index == 4) {
                item.start = common.getday(common.getDate(), -1);
                item.end = common.getDate(); //昨天
            } else if(index == 5) {
                item.start = '2021-01-01';
                item.end = common.getDate(); //当前时间
            };
        })
        this.gteTimeData();
    } else {
        fetchVerifyAuthForB(() => {
           this.getPerformanceSearch();
        });
    }



    },
    name: "index",
    data() {
        return {
            isShow: false, //是否展开
            typeTime: "",
            startTime: "", //开始时间
            endTime: "", //结束时间
            bDateTime: false,
            minDate: new Date(2010, 0, 1), //最小时间
            maxDate: new Date(), //最大时间
            currentDate: new Date(new Date().setDate(new Date().getDate() - 1)), //当前时间
            popShow: false,
            selectTitle: "",
            columns: [
                // { title: '第一大区', id: 1 }, { title: '第二作战区', id: 2 }, { title: '第三战区', id: 3 }
            ],
            areaForm: [{}, {}, {}, {}, {}],
            curSelect: 0,
            curDate: 1,
            dateList: [
                {title:'总计'},
                {title:'年累计'},
                {title:'月累计'},
                {title:'周累计'},
                {title:'昨日'},
                {title:'自定义'},
            ],
            //大区
            arrAgent: [],
            //城市
            arrArea: [],
            //渠道
            arrChannel: [],
            //代理商
            arrCity: [],
            //签单手
            arrWorker: [],

            //搜索表单
            searchForm: {
                //...
                agent: "",
                area: "",
                channel: "",
                city: "",
                worker: "",
                start: "",
                end: "",
            },
            //sPhone: "",
            bCustom: false,
            scartext: '', //搜索默认值
        };
    },
    methods: {
        //隐藏显示
        executeAnimation() {
            if (this.isShow) {
                this.isShow = false;
                // document
                //     .getElementById("content-box")
                //     .setAttribute("class", "no-show");
                document
                    .getElementById("img")
                    .setAttribute("class", "spanReset");
            } else {
                this.isShow = true;
                // document
                //     .getElementById("content-box")
                //     .classList.remove("no-show");
                document
                    .getElementById("img")
                    .setAttribute("class", "spanRotate");
            }
        },

        // 确认时间
        getConfirm(e) {
            let y = e.getFullYear();
            let d = e.getMonth() + 1;
            let m = e.getDate();
            this[this.typeTime] = y + "-" + d + "-" + m;
            // console.log(this[this.typeTime]);
            this.bDateTime = false;

            //.....
            //因为没有确定按钮 无语死了
            if (this.endTime && this.startTime) {
                //如果开始时间 结束时间都有的情况下
                //清空自定义
                this.curDate = -1;
                this.searchForm.start = this.startTime;
                this.searchForm.end = this.endTime;
                this.sendSearchForm();
            }
        },
        // 取消
        getCancel() {
            this.bDateTime = false;
        },
        // 打开选择器
        openSelect(index) {
            this.curSelect = index;
            switch (index) {
                case 0:
                    this.selectTitle = "选择大区";
                    //this.columns = [{ title: '第一大区', id: 1 }, { title: '第二作战区', id: 2 }, { title: '第三战区', id: 3 }];
                    this.columns = this.arrArea;
                    this.popShow = true;
                    break;
                case 1:
                    //if (this.searchForm.area == "") {
                    //this.$toast("请先选择大区");
                    //} else {
                    this.selectTitle = "选择城市";
                    this.columns = this.arrCity;
                    this.popShow = true;
                    //}
                    //this.columns = [{ title: '北京' }, { title: '上海' }, { title: '南昌' }];
                    break;
                case 2:
                    //if (this.searchForm.area == "") {
                    //this.$toast("请先选择大区");
                    //} else {
                    this.selectTitle = "选择渠道";
                    //this.columns = [{ title: '渠道一' }, { title: '渠道二' }, { title: '渠道三' }];
                    this.columns = this.arrChannel;
                    this.popShow = true;
                    //}
                    break;
                case 3:
                    //if (this.searchForm.area == "") {
                    //this.$toast("请先选择大区");
                    //} else {
                    this.selectTitle = "选择代理商";
                    this.columns = this.arrAgent;
                    this.popShow = true;
                    //}
                    //this.columns = [{ title: '代理商一' }, { title: '代理商二' }, { title: '代理商三' }];
                    break;
                case 4:
                    //if (this.searchForm.agent == "") {
                    //this.$toast("请先选择代理商");
                    //} else {
                    this.selectTitle = "选择签单手";
                    //this.columns = [{ title: '签单手一' }, { title: '签单手二' }, { title: '签单手三' }];
                    this.columns = this.arrWorker;
                    this.popShow = true;
                    //}
                    break;
            }
        },
        //选择器确定监听
        onConfirm(e) {
            let title = e
            if (e.title) {
                title = e.title;
            }
            console.log(title,'title')
            this.popShow = false;

            // wcp 修改 start
            if (!e.length && !e.title) {
                return
            }
            console.log(11111)
            this.$set(this.areaForm,this.curSelect,{})
            this.$set(this.areaForm[this.curSelect],'title',title)
            // wcp 修改 end

            if (e == '全部') {
                e = ''
            }
            this.$forceUpdate();
            switch (this.curSelect) {
                case 0:

                    this.searchForm.area = e.id;
                    //清空其他所有条件 互斥
                    this.areaForm = [this.areaForm[0], {}, {}, {}, {}];
                    this.searchForm.agent = "";
                    //this.searchForm.channel = ""; 渠道不用管
                    this.searchForm.city = "";
                    this.searchForm.worker = "";
                    this.getPerformanceSearch();
                    break;
                case 1:
                    this.searchForm.city = e.id;
                    break;
                case 2:
                    this.searchForm.channel = e.id;
                    break;
                case 3:
                    this.searchForm.agent = e.id;
                    this.getPerformanceSearch();
                    //清空签单手
                    // this.areaForm = [
                    //     this.areaForm[0],
                    //     this.areaForm[1],
                    //     this.areaForm[2],
                    //     this.areaForm[3],
                    //     {},
                    // ];
                    // this.searchForm.worker = "";
                    break;
                case 4:

                    this.searchForm.worker = e.id || e.user_id_sign;
                    break;
            }
            this.sendSearchForm();
        },
        // 切换日期
        //选择器改变监听
        changeSelectDate(index) {
            console.log(index, this.curDate, '垃圾')
            if (index === this.curDate && !this.newtime) {
                //this.curDate = -1
                //this.searchForm.start=""
                //this.searchForm.end=""
            } else {
                // if (index == 3) {
                //     // document
                //     //     .getElementById("choose-time")
                //     //     .setAttribute("class", "cycle-wrap");
                //     this.bCustom = true
                // } else {
                //     this.bCustom = false
                //     // document
                //     //     .getElementById("choose-time")
                //     //     .setAttribute("class", "cycle-wrap no-show");
                //     let date = this.dateList[index];
                //     // console.log(date);
                //     this.searchForm.start = date.start;
                //     this.searchForm.end = date.end;

                //     this.startTime = date.start
                //      this.endTime = date.end
                //     this.sendSearchForm();
                // }
                    this.bCustom = false
                    // document
                    //     .getElementById("choose-time")
                    //     .setAttribute("class", "cycle-wrap no-show");
                    let date = this.dateList[index];
                console.log(date,'date')
                    this.searchForm.start = date.start;
                    console.log(date.end,'date.end');
                    this.searchForm.end = date.end;
                    this.startTime = date.start
                    this.endTime = date.end
                    this.sendSearchForm();
                this.curDate = index;
            }
        },
        //获取搜索数据
        getPerformanceSearch() {
            console.log(this.searchForm.area,'this.searchForm.area')
            // this.$store.commit("loadSwitch", true);
            let data = {
                area: this.searchForm.area,
                agent: this.searchForm.agent,
                //skip_phone: this.sPhone,
            };
            // this.sendSearchForm();
            if (this.$route.path == '/performance/result/operate') {
                return
            }

            oAnalysisJs.getPerformanceSearch(data).then((res) => {
                this.$store.commit("loadSwitch", false);
                let data = res.data.data.result;
                //console.log(data)
                    this.arrArea = data.area;
                    this.arrChannel = data.channel;
                    this.arrCity = data.city;
                    this.arrWorker = data.worker;
                    this.arrAgent = data.agent;

                this.dateList = data.period;

                //默认选中昨天 如果没有事件 给一个默认 发送通知

                if (this.searchForm.start == "") {
                    console.log(this.dateList);
                    this.dateList.forEach((item, index) => {
                        //console.log(item,index)
                        if (item.checked) {
                            console.log(item,'item')
                            this.curDate = index
                            this.searchForm.start = item.start;
                            this.searchForm.end = item.end;
                            // this.searchForm.area =
                            if (index == 1) {
                                console.log(item.start,'item.start')
                                this.startTime = item.start
                                this.endTime = item.end
                                this.bCustom=true
                            }
                        }
                    })
                    this.sendSearchForm();
                }

                // if (this.searchForm.start == "") {
                //     let date = this.dateList[3];
                //     if (date.start) {
                //         this.searchForm.start = date.start;
                //         this.searchForm.end = date.end;
                //     } else {
                //         this.startTime = "2021-01-01"
                //         this.endTime = this.dateList[2].end
                //         this.searchForm.start = "2021-01-01";
                //         this.searchForm.end = this.dateList[2].end;
                //     }
                //     this.sendSearchForm();
                // }
            });
        },
        //发送选择的数据
        sendSearchForm() {
            console.log(this.searchForm,'searchForm')
            this.$emit("searchForm", this.searchForm);
        },
        gteTimeData() {   // 体验见搜搜数据
            getsearch().then( res => {
                let newArr = res.data.data.result;

                this.arrArea = ['全部',...newArr.area];
                this.arrCity = ['全部',...newArr.city];
                this.arrChannel = ['全部',...newArr.source];
                this.arrAgent = ['全部',...newArr.platform];

                newArr.sign.forEach( item => {
                    this.arrWorker.push({
                        'user_id_sign' : item.user_id_sign,
                        'title' : item.sign_name,
                        'sign_phone' : item.sign_phone
                    })

                });

                //默认选中昨天 如果没有事件 给一个默认 发送通知
                this.changeSelectDate(1)

                // if (this.searchForm.start == "") {
                //     console.log(this.dateList);
                //     this.dateList.forEach((item, index) => {
                //         //console.log(item,index)
                //         if (item.checked) {
                //             this.curDate = index
                //             this.searchForm.start = item.start;
                //             this.searchForm.end = item.end;
                //             if (index == 1) {
                //                 this.startTime = item.start
                //                 this.endTime = item.end
                //                 this.bCustom=true
                //             }
                //         }
                //     })
                //     this.sendSearchForm();
                // }
            })
        },
        searchText(value) {   // 搜索关键词
            this.scartext = value;
            if(this.curSelect == 3) {
                this.columns = [] = this.arrAgent.filter( item => item.indexOf(value) >= 0 );

            } else if(this.curSelect == 4) {
                this.columns = [] = this.arrWorker.filter( item => item.title.indexOf(value) >= 0 );
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.fade-transform-leave-active,
.fade-transform-enter-active {
    transition: all 0.5s;
}
.fade-transform-enter {
    opacity: 0;
    transform: translateY(-30px);
}
.fade-transform-leave-to {
    opacity: 0;
    transform: translateY(-30px);
}
.filter-wrap {
    width: 93.6%;
    margin: 24px auto;
    background: #fff;
    padding: 28px 24px;
    border-radius: 12px;

    .filter-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
        line-height: 40px;
        div {
            flex: 1;
        }
        span {
            margin-right: 10px;
            font-size: 24px;
        }
        img {
            width: 32px;
            height: 32px;
        }
    }

    .select-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 20px 0 28px;
        border-bottom: 2px dashed #f1f1f1;
        margin-bottom: 26px;
        .select-top-wrap {
            display: flex;
            justify-content: space-between;
            align-items: center;

            div {
                width: 46%;

                div {
                    width: 70%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }

        .select-item {
            padding: 0 18px;
            border-radius: 12px;
            border: 2px solid #dbdbdb;
            display: flex;
            align-items: center;
            justify-content: space-between;

            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #858585;
            line-height: 60px;

            img {
                width: 32px;
                height: 32px;
            }

            &:nth-child(3),
            &:nth-child(4) {
                margin-top: 24px;
            }
        }

        .select-left {
            width: 65%;
        }

        .select-right {
            width: 30%;
        }
    }

    .cycle-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;
        .date_time {
            width: 40%;
            border-radius: 12px;
            border: 2px solid #dbdbdb;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            text-align: center;
            color: #444444;
            line-height: 60px;
        }
        .cycle-item {
            width: 14.2%;
            border-radius: 12px;
            border: 2px solid #dbdbdb;
            font-size: 25px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            text-align: center;
            color: #444444;
            line-height: 60px;
        }

        .cycle-item-act {
            border-color: #318544;
            color: #318544;
        }
    }
    .no-show {
        display: none;
        //    height: 0; overflow: hidden;
    }
    .no-show > * {
        display: none;
        //  height: 0; overflow: hidden;
    }
    .spanRotate {
        transform: rotate(180deg);

        -webkit-transform: rotate(180deg);

        transition: transform 0.5s;
    }

    .spanReset {
        transform: rotate(0deg);

        -webkit-transform: rotate(0deg);

        transition: transform 0.5s;
    }
}
</style>
